/* Sense — boutons « Modifier » et « Retirer » de la ligne de pack, dans le tiroir panier et la page panier. */
(() => {
  const ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function removeLines(keys, row) {
    // Le thème sait redessiner le panier : on réutilise ses propres éléments
    const drawerItems = row.closest('cart-drawer') && document.querySelector('cart-drawer cart-items');
    const pageItems = !drawerItems && document.querySelector('main-cart-items');
    const helper = drawerItems || pageItems;
    // Envoi en formulaire : certaines applis réécrivent les envois JSON vers le panier
    const body = new FormData();
    keys.forEach(k => body.append(`updates[${k}]`, '0'));
    if (helper && typeof helper.getSectionsToRender === 'function') {
      body.append('sections', [...new Set(helper.getSectionsToRender().map(s => s.section))].join(','));
      body.append('sections_url', window.location.pathname);
    }
    const res = await fetch(`${ROOT_URL}cart/update.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || '');
    return { data, drawerItems, pageItems };
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-sp-pack-remove],[data-sp-pack-edit]');
    if (!btn) return;
    e.preventDefault();
    const row = btn.closest('[data-sp-cart-pack]');
    const keys = String(btn.dataset.keys || '').split(',').filter(Boolean);
    if (!keys.length || row.classList.contains('is-loading')) return;
    row.classList.add('is-loading');
    const isEdit = btn.hasAttribute('data-sp-pack-edit');
    try {
      const { data, drawerItems, pageItems } = await removeLines(keys, row);
      if (isEdit) {
        // Le pack revient sur sa page avec les mêmes parfums
        const picks = [];
        String(btn.dataset.picks || '').split(',').filter(Boolean).forEach(pair => {
          const [v, q] = pair.split(':');
          for (let i = 0; i < (Number(q) || 1); i++) picks.push(Number(v));
        });
        try { localStorage.setItem(btn.dataset.storageKey, JSON.stringify({ size: Number(btn.dataset.size) || picks.length, picks })); } catch (err) {}
        window.location.href = btn.dataset.url;
        return;
      }
      // Page panier vidée : le thème n'a pas de rendu « panier vide » sans recharger
      if (pageItems && data.item_count === 0) { window.location.reload(); return; }
      if (drawerItems && data.sections && typeof drawerItems.updateCartDrawer === 'function') drawerItems.updateCartDrawer(data);
      else if (pageItems && data.sections && typeof pageItems.updateMainCart === 'function') pageItems.updateMainCart(data);
      else window.location.reload();
    } catch (err) {
      row.classList.remove('is-loading');
      window.location.reload();
    }
  });

  /* ---------- Message d'économie après l'ajout d'un pack (préparé par sense-pack.js) ---------- */
  const SAVED_KEY = 'sense-pack:saved';
  const SAVED_MS = 6000;
  const CHECK = '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const CROSS = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function takeSaved() {
    try {
      const raw = sessionStorage.getItem(SAVED_KEY);
      sessionStorage.removeItem(SAVED_KEY);
      const d = raw && JSON.parse(raw);
      return d && Date.now() - d.t < 120000 ? d : null;
    } catch (e) { return null; }
  }

  // Tiroir mobile (feuille du bas) : juste au-dessus ; tiroir latéral : à côté ; sinon en bas au centre
  function place(el) {
    el.style.top = el.style.bottom = el.style.left = el.style.width = '';
    const panel = document.querySelector('cart-drawer.active .drawer__body');
    const r = panel && panel.getBoundingClientRect();
    if (!r || !r.width || r.top >= window.innerHeight || r.bottom <= 0) return;
    if (r.left <= 8) {
      if (r.top - 24 >= el.offsetHeight) el.style.bottom = `${window.innerHeight - r.top + 12}px`;
      else { el.style.top = '12px'; el.style.bottom = 'auto'; }
    } else if (r.left >= 320) {
      el.style.left = `${r.left / 2}px`;
      el.style.width = `${Math.min(460, r.left - 32)}px`;
    }
  }

  function showSaved() {
    const d = takeSaved();
    if (!d) return;
    document.querySelectorAll('.sp-saved').forEach(x => x.remove());
    const el = document.createElement('div');
    el.className = 'sp-saved';
    el.setAttribute('role', 'status');
    el.innerHTML = `<span class="sp-saved__icon" aria-hidden="true">${CHECK}</span>
      <div class="sp-saved__text"><p class="sp-saved__title"></p><p class="sp-saved__line"></p><p class="sp-saved__detail"></p></div>
      <button type="button" class="sp-saved__close" aria-label="Fermer le message">${CROSS}</button>
      <span class="sp-saved__bar" aria-hidden="true"></span>`;
    el.querySelector('.sp-saved__title').textContent = d.title || '';
    const amount = document.createElement('b');
    amount.textContent = d.amount || '';
    el.querySelector('.sp-saved__line').append(d.before || '', amount, d.after || '');
    el.querySelector('.sp-saved__detail').textContent = d.detail || '';
    // Le tiroir du thème s'ouvre dans la couche supérieure du navigateur : le message doit y passer aussi, sinon il reste sous le voile
    const layered = typeof el.showPopover === 'function';
    if (layered) el.setAttribute('popover', 'manual');
    document.body.appendChild(el);
    if (layered) { try { el.showPopover(); } catch (e) {} }

    let remaining = SAVED_MS, started = 0, timer = 0;
    const follow = setInterval(() => place(el), 250);
    const hide = () => {
      clearTimeout(timer);
      clearInterval(follow);
      el.classList.remove('is-in');
      setTimeout(() => { if (layered) { try { el.hidePopover(); } catch (e) {} } el.remove(); }, 350);
    };
    const run = () => { started = Date.now(); timer = setTimeout(hide, remaining); el.classList.remove('is-paused'); };
    const pause = () => { clearTimeout(timer); remaining -= Date.now() - started; el.classList.add('is-paused'); };
    el.querySelector('.sp-saved__close').addEventListener('click', hide);
    el.addEventListener('pointerenter', pause);
    el.addEventListener('pointerleave', run);

    // Tiroir ouvert : on attend qu'il soit monté à l'écran et immobile avant d'afficher (page panier : tout de suite)
    let last = NaN, tries = 0;
    const settle = () => {
      const panel = document.querySelector('cart-drawer.active .drawer__body');
      const top = panel ? Math.round(panel.getBoundingClientRect().top) : null;
      const ready = top === null || (top < window.innerHeight - 40 && top === last);
      if (!ready && tries++ < 40) { last = top; setTimeout(settle, 80); return; }
      place(el);
      el.classList.add('is-in');
      run();
    };
    settle();
  }

  // Tiroir ouvert sur la page pack : on laisse le tiroir finir de s'ouvrir
  document.addEventListener('sense-pack:added', () => setTimeout(showSaved, 400));
  // Page panier (ordinateur) : le message suit la redirection
  setTimeout(showSaved, 300);
})();
